/* eslint-disable */

import sip from '../assets/Navbar/sip.svg'
import {
  AddCircle,
  AddCircleOutline,
  AdminPanelSettings,
  AdminPanelSettingsOutlined,
  BarChart,
  BarChartOutlined,
  EqualizerOutlined,
  EqualizerRounded,
  HomeOutlined,
  HomeRounded,
  ListAltOutlined,
  ListAltRounded,
  SipOutlined,
  SipRounded,
  TravelExplore,
  TravelExploreOutlined,
  WidgetsOutlined,
  WidgetsRounded,
} from '@mui/icons-material'

export const navbarData = [
  {
    id: 1,
    icon: <HomeOutlined />,
    iconIsActive: <HomeRounded />,
    link: '/dashboard',
    title: 'Home',
  },
  {
    id: 2,
    icon: <TravelExploreOutlined />,
    iconIsActive: <TravelExplore />,
    link: '/dashboard/mutual-funds',
    title: 'Discover',
  },
  {
    id: 3,
    icon: <EqualizerOutlined />,
    iconIsActive: <EqualizerRounded />,
    link: '/dashboard/mutual-funds/investments',
    title: 'Portfolio',
  },

  {
    id: 4,
    icon: <SipOutlined />,
    iconIsActive: <SipRounded />,
    link: '/dashboard/mutual-funds/sips',
    title: 'SIPs',
  },
  // {
  //   id: 5,
  //   icon: <WidgetsOutlined />,
  //   iconIsActive: <WidgetsRounded />,
  //   link: '',
  //   title: 'More',
  // },
  {
    id: 10,
    icon: <ListAltOutlined />,
    iconIsActive: <ListAltRounded />,
    link: '/dashboard/mutual-funds/orders',
    title: 'Orders',
  },

  // {
  //   id: 10,
  //   icon: sip,
  //   link: '/dashboard/plans',
  //   title: 'Goals',
  // },
]

export const navTitles = [
  {
    linkName: 'Home',
    linkPath: '/dashboard',
    pathName: 'home',
    highlightUrls: ['/dashboard'],
  },

  // {
  //   linkName: 'Plan a Goal',
  //   linkPath: '/dashboard/plans',
  //   pathName: 'plan',

  //   highlightUrls: [
  //     '/dashboard/plans',
  //     '/dashboard/vacationplan',
  //     '/dashboard/emergencyplan',
  //     '/dashboard/weddingplan',
  //     '/dashboard/purchaseplan',
  //     '/dashboard/retirementplan',
  //     '/dashboard/educationplan',
  //     '/dashboard/invest',
  //   ],
  // },
  {
    linkName: 'My Portfolio',
    linkPath: '/dashboard/portfolio',
    pathName: 'portfolio',
    iconName: 'real_estate_agent',
    highlightUrls: ['/dashboard/portfolio', '/dashboard/holdings'],
  },
  {
    linkName: 'SIPs',
    linkPath: '/dashboard/sips',
    pathName: 'sips',

    highlightUrls: ['/dashboard/sips', '/dashboard/e-mandate'],
  },

  {
    linkName: 'Account Balance',
    linkPath: '/dashboard/funds',
    pathName: 'funds',
    iconName: 'account_balance_wallet',
    highlightUrls: ['/dashboard/funds'],
  },

  {
    linkName: 'Discover Top funds',
    linkPath: '/dashboard/theme',
    pathName: 'theme',
    iconName: 'bubble_chart',
    highlightUrls: ['/dashboard/theme', '/dashboard/theme-details'],
  },
  {
    linkName: 'IPO',
    linkPath: '/dashboard/ipo',
    pathName: 'ipo',
    iconName: 'add_business',
    highlightUrls: ['/dashboard/ipo'],
  },
  {
    linkName: 'Gold Bonds',
    linkPath: '/dashboard/goldbonds',
    pathName: 'gold',
    iconName: 'stacks',
    highlightUrls: ['/dashboard/goldbonds'],
  },

  {
    linkName: 'Insurance',
    linkPath: '/dashboard/insurance',
    pathName: 'insurance',
    iconName: 'admin_panel_settings',
    highlightUrls: ['/dashboard/insurance'],
  },

  // {
  //   linkName: 'Support',
  //   linkPath: '/dashboard/support',
  //   pathName: 'support',
  //   iconName: 'admin_panel_settings',
  //   highlightUrls: ['/dashboard/support'],
  // },

  {
    linkName: 'Refer & Rewards',
    linkPath: '/dashboard/refer',
    pathName: 'refer',
    iconName: 'admin_panel_settings',
    highlightUrls: ['/dashboard/refer'],
  },

  {
    linkName: 'Profile',
    linkPath: '/dashboard/profile',
    pathName: 'profile',
    iconName: 'admin_panel_settings',
    highlightUrls: ['/dashboard/profile'],
  },
  // {
  //   linkName: 'Plan a Goal',
  //   linkPath: '/dashboard/homepurchase',
  //   pathName: 'insurance',
  //   iconName: 'admin_panel_settings',
  //   highlightUrls: ['/dashboard/insurance'],
  // },
]

export const navbarTitles = [
  {
    id: 1,
    icon: 'home',
    link: '/dashboard',
    title: 'Home',
  },
  {
    id: 2,
    icon: 'bubble_chart',
    link: '/dashboard/theme',
    title: 'Discover Top Funds',
  },

  {
    id: 4,
    icon: 'real_estate_agent',
    link: '/dashboard/portfolio',
    title: 'Portfolio',
  },
  {
    id: 5,
    icon: 'widgets',
    link: '',
    title: 'More',
  },
  {
    id: 6,
    icon: '/Navbar/goldbonds.svg',
    link: '/dashboard/goldbonds',
    title: 'Gold Bonds',
  },
  {
    id: 7,
    icon: '/Navbar/ipo.svg',
    link: '/dashboard/ipo',
    title: 'IPO',
  },
  {
    id: 8,
    icon: '/Navbar/insurance.svg',
    link: '/dashboard/insurance',
    title: 'Insurance',
  },
  {
    id: 10,
    icon: '/Navbar/sip.svg',
    link: '/dashboard/sips',
    title: 'SIPs',
  },
  // {
  //   id: 11,
  //   icon: '/Navbar/wallet.svg',
  //   link: '/dashboard/funds',
  //   title: 'Wallet',
  // },
]

export const navbarDataNonDemat = [
  {
    id: 1,
    icon: <HomeOutlined />,
    iconIsActive: <HomeRounded />,
    link: '/dashboard',
    title: 'Home',
  },
  {
    id: 2,
    icon: <TravelExploreOutlined />,
    iconIsActive: <TravelExplore />,
    link: '/dashboard/mutual-funds',
    title: 'Discover',
  },
  {
    id: 3,
    icon: 'handshake',
    link: '',
    title: 'KYC',
  },

  {
    id: 4,
    icon: <AdminPanelSettingsOutlined />,
    iconIsActive: <AdminPanelSettings />,
    link: '/dashboard/insurance',
    title: 'Insurance',
  },
  {
    id: 5,
    icon: <BarChart />,
    iconIsActive: <BarChartOutlined />,
    link: '',
    title: '2025',
  },
]
